import Vue from 'vue'
import Router from 'vue-router'
import { store } from '../store/index'

import EnterPage from '@/components/EnterPage'
import LoginPage from '@/components/LoginPage'
import MainPage from '@/components/MainPage'
import ReportPage from '@/components/ReportPage'
import Reports from '@/components/MainPage/components/Reports/Reports.vue'
import Archive from '@/components/MainPage/components/Archive/Archive'
import Profile from '@/components/MainPage/components/Profile/Profile.vue'
import Draft from '@/components/MainPage/components/Draft/Draft.vue'
import Redirect from '@/components/LoginPage/Redirect.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'enter',
      component: EnterPage
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
    {
      path: '/redirect',
      name: 'redirect',
      component: Redirect
    },
    {
      path: '/main',
      component: MainPage,
      beforeEnter: AuthGuard,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/main',
          redirect: to => {
            const isAdmin = store.state.auth.isAdmin
            if (isAdmin) return '/main/respondents'
            else return '/main/reporting'
          }
        },
        {
          path: '/main/reporting',
          name: 'reports',
          component: Reports,
          beforeEnter: AuthGuard
        },
        {
          path: '/main/draft',
          name: 'draft',
          component: Draft,
          beforeEnter: AuthGuard
        },
        {
          path: '/main/archive',
          name: 'archive',
          component: Archive,
          beforeEnter: AuthGuard
        },
        {
          path: '/main/profile',
          name: 'profile',
          component: Profile,
          beforeEnter: AuthGuard
        },
        {
          path: '/main/respondents',
          name: 'respondents',
          component: () => import('../components/MainPage/curatorsComponents/Respondents/Respondents'),
          beforeEnter: AuthGuard,
          meta: { form: 'respondents' }
        },
        {
          path: '/main/curator-archive',
          name: 'curator-archive',
          component: () => import('../components/MainPage/curatorsComponents/Archive/Archive'),
          beforeEnter: AuthGuard,
          meta: { form: 'archive' }
        },
        {
          path: '/main/curator-reports',
          name: 'curator-reports',
          component: () => import('../components/MainPage/curatorsComponents/Reporting/Reporting'),
          beforeEnter: AuthGuard,
          meta: { form: 'reports' }
        }
      ]
    },
    {
      path: '/report/:id',
      component: ReportPage,
      beforeEnter: AuthGuard,
      props: true
    },
    {
      path: '/report/view/:id',
      name: 'report-view',
      component: () => import('../components/ViewReport/index.vue'),
      beforeEnter: AuthGuard
    },
    {
      path: '/edit-report/:id/:statReportId/',
      name: 'edit-report',
      component: ReportPage,
      props: true,
      beforeEnter: AuthGuard
    }
  ]
})

function AuthGuard(to, from, next) {
  const token = localStorage.getItem('token')
  if (token) next()
  else next('/')
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js